export default __webpack_public_path__ + "static/media/discord-yellow.c26d9e2d.svg";